import React, { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import 'primeflex/primeflex.css';
import { ToastContext } from 'app/context/ToastContext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from 'primereact/button';
import { Editor } from 'primereact/editor';
import { getConfiguration, saveConfiguration } from 'app/api/configurationApi';

const ClientConfiguration: React.FC = () => {
  const { key } = useParams<{ key?: string }>(); // Capture id from URL
  const navigate = useNavigate();
  const { showSuccess, showError } = useContext(ToastContext);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const fileUploadRef = useRef(null);
  const [image, setImage] = useState(null);

  useEffect(() => {
    if (key) {
      getConfiguration(key)
        .then(response => {
          if (response.data) {
            setData(response.data);
          }
        })
        .catch(error => {
          console.error(error);
          showError('Chyba', error.response?.data?.detail);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [key]);

  const onSubmit = () => {
    saveConfiguration(key, data)
      .then(response => {
        showSuccess('Úspech', 'Text úspešne uložený.');
        setData(response.data);
      })
      .catch(error => {
        console.error('Error creating agent:', error);
        showError('Chyba', error.response?.data?.detail);
      })
      .finally(() => setIsSaving(false));
  };

  return (
    <div className="card">
      {loading && (
        <div className="flex justify-content-center">
          <ProgressSpinner />
        </div>
      )}

      {!loading && (
        <>
          <h2>{key === 'conditions' ? 'Upraviť podmienky používania' : 'Upraviť spracovanie osobných údajov'}</h2>

          <Editor value={data} onTextChange={e => setData(e.htmlValue)} style={{ height: '150px' }}></Editor>
          <Button
            style={{ backgroundColor: '#e31818' }}
            type="button"
            onClick={onSubmit}
            label="Uložiť"
            icon="pi pi-check"
            className="p-mt-3"
            disabled={isSaving}
          />
        </>
      )}
    </div>
  );
};

export default ClientConfiguration;
